import React from 'react'
import PanelContainer from 'containers/panel/admin/panel-container'

const MainPage = () => {
  return (
    <PanelContainer />
  )
}

export default MainPage